module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	fox.registerWidget('SocialNetwork_Oauth_Signup', {

		configure: function(options) {
			this.registerOptions('', {
				mode: 'signup',
				list: {
					'tpl.row': 'socialnetwork_oauth_signup',
					'embed.container': '#temp_oauth_signup',
					handleDom: {
						socialClick: {
							target: 'a.default-link',
							event: 'click',
							callback: '@parent:socialClickHandler'
						}
					}
				},
				'handleWom.recieveProfile': {
					widget: '@this',
					event: 'recieveProfile',
					callback: 'fillProfile',
				}
			});

			this.callParent('configure', arguments);
		},

		fillProfile: function(data) {
			var scope = this;

			fox.each(data.userInfo, function(fieldValue, fieldName) {
				if (fieldValue === '') {
					return;
				}

				switch (fieldName) {
					case 'email':
						scope.fillProfileField('email', fieldValue);
					break;
					case 'firstName':
						scope.fillProfileField('firstName', fieldValue);
					break;
					case 'lastName':
						scope.fillProfileField('lastName', fieldValue);
					break;
					case 'screen':
						scope.fillProfileField('screenName', fieldValue);
					break;
				}
			});
		},

		fillProfileField: function(fieldName, fieldValue) {
			var promoReg = this.getParent();
			promoReg.showSuccess(fieldName);
			promoReg.dom1('[name="' + fieldName + '"]').value = fieldValue;
		}

	}, 'SocialNetwork_Oauth');
})(fox);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/widget/socialNetwork/oauth/signup.js
// module id = 359
// module chunks = 2